import React, { useEffect, useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col,
    Spinner
} from "reactstrap";

import BasicModal from '../../../../components/Modals/BasicModal'
import SelectTeachers from './SelectTeachers';
import SelectStudents from './SelectStudents';
import { titleCase } from '../../../../utils/views/pages/Dynamics'

const ManagementInformation = (props) => {
    const group = props.group
    const formDisabled = props.formDisabled
    const setGroup = props.setGroup
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const studentsOptions = props.studentsOptions
    const teachersOptions = props.teachersOptions
    const showStudents = props.showStudents
    const showTeachers = props.showTeachers
    const validations = props.validations

    let validateField = (e) => {
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {

        group[e.target.name] = e.target.value
        setGroup(group)

    }

    return (
        <>
            {/* Address */}
            <h6 className="heading-small text-muted mb-4">
                Management information
            </h6>
            <div className="pl-lg-4">
                {function () {

                    return (
                        <Row>
                            <Col lg="6">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-app"
                                    >
                                        Teachers
                                    </label>

                                    {!showTeachers ?
                                        <div className="text-center p-1">
                                            <Spinner size="lg" />
                                        </div>
                                        :
                                        <SelectTeachers
                                            formDisabled={formDisabled}
                                            setGroup={setGroup}
                                            selectOptions={teachersOptions}
                                            group={group} />
                                    }

                                </FormGroup>
                            </Col>
                            <Col lg="6">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-app"
                                    >
                                        Students
                                    </label>

                                    {!showStudents ?
                                        <div className="text-center p-1">
                                            <Spinner size="lg" />
                                        </div>
                                        :
                                        <SelectStudents
                                            formDisabled={formDisabled}
                                            setGroup={setGroup}
                                            selectOptions={studentsOptions}
                                            group={group} />
                                    }

                                </FormGroup>
                            </Col>
                        </Row>

                    )

                }()

                }


                <Row>
                    <Col md="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-detail"
                            >
                                Details
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={group?.detail}
                                id="input-detail"
                                name="detail"
                                placeholder="Group Details"
                                type="textarea"
                                rows="5"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={false}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                </Row>

            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />

        </>
    )
}

export default ManagementInformation;